// @flow

import client from 'client/client';

export default (locale: string) =>
  import(/* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
  `../../public/locale/${locale}/messages.js`).then(catalog => client(catalog, locale));
